import { Injectable } from '@angular/core';
import { DspxBaseFormComponent } from 'dspx-core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class Form48HelperService {
  constructor(
  ) { }

  public registerListeners(baseForm: DspxBaseFormComponent){

    const formGroup = baseForm.form.controls.form as FormGroup;

    this.getDoubleStretcherVehiclesControl(formGroup)?.valueChanges.subscribe(() => {
      this.calculateTotalStretcherVehicles(baseForm);
    });

    this.getSingleStretcherVehiclesControl(formGroup)?.valueChanges.subscribe(() => {
      this.calculateTotalStretcherVehicles(baseForm);
    });


    this.getFixedWingAircraftsControl(formGroup)?.valueChanges.subscribe(() => {
      this.calculateTotalOfAircrafts(baseForm);
    });

    this.getRotaryWingAircraftsControl(formGroup)?.valueChanges.subscribe(() => {
      this.calculateTotalOfAircrafts(baseForm);
    });
  }

  public calculateTotalStretcherVehicles(baseForm: DspxBaseFormComponent) {
    const formGroup = baseForm.form.controls.form as FormGroup;
    const doubleStretcherVehiclesControl = this.getDoubleStretcherVehiclesControl(formGroup);
    const singleStretcherVehiclesControl = this.getSingleStretcherVehiclesControl(formGroup);
    const totalStretcherVehiclesControl = formGroup.get('tabs.tab1.page2.section_3.textField_6');

    if (doubleStretcherVehiclesControl?.value != null && singleStretcherVehiclesControl?.value != null) {
      const doubleStretcherVehicles = +doubleStretcherVehiclesControl.value;
      const singleStretcherVehicles = +singleStretcherVehiclesControl.value;

      if (isNaN(doubleStretcherVehicles) || isNaN(singleStretcherVehicles)) {
        return;
      }

      const calculatedTotalStretcherVehicles = doubleStretcherVehicles + singleStretcherVehicles;

      if (calculatedTotalStretcherVehicles !== +totalStretcherVehiclesControl.value) {
          totalStretcherVehiclesControl.patchValue(calculatedTotalStretcherVehicles);
      }
    }
  }

  public calculateTotalOfAircrafts(baseForm: DspxBaseFormComponent) {
    const formGroup = baseForm.form.controls.form as FormGroup;
    const fixedWingAircraftsControl = this.getFixedWingAircraftsControl(formGroup);
    const rotaryWingAircraftsControl = this.getRotaryWingAircraftsControl(formGroup);
    const totalOfAircraftsControl = formGroup.get('tabs.tab1.page2.section_3.textField_17');

    if (fixedWingAircraftsControl?.value != null && rotaryWingAircraftsControl?.value != null) {
      const fixedWingAircrafts = +fixedWingAircraftsControl.value;
      const rotaryWingAircrafts = +rotaryWingAircraftsControl.value;

      if (isNaN(fixedWingAircrafts) || isNaN(rotaryWingAircrafts)) {
        return;
      }

      const calculatedTotalOfAircrafts = fixedWingAircrafts + rotaryWingAircrafts;

      if (calculatedTotalOfAircrafts !== +totalOfAircraftsControl.value) {
          totalOfAircraftsControl.patchValue(calculatedTotalOfAircrafts);
      }
    }
  }

  private getSingleStretcherVehiclesControl(formGroup: FormGroup<any>) {
    return formGroup.get('tabs.tab1.page2.section_3.textField_3');
  }

  private getDoubleStretcherVehiclesControl(formGroup: FormGroup<any>) {
    return formGroup.get('tabs.tab1.page2.section_3.textField_2');
  }

  private getFixedWingAircraftsControl(formGroup: FormGroup<any>) {
    return formGroup.get('tabs.tab1.page2.section_3.textField_8');
  }

  private getRotaryWingAircraftsControl(formGroup: FormGroup<any>) {
    return formGroup.get('tabs.tab1.page2.section_3.textField_9');
  }
}
